import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { Location } from "@curai/js-fhir-tools";

export enum PharmacyInvalidReason {
  MISSING_VENDOR_ID = "MISSING_VENDOR_ID",
}

interface GetPreferredPharmacyResponse {
  pharmacy?: Location;
  pharmacyInvalidReason?: PharmacyInvalidReason;
}

export const usePreferredPharmacy = ({ patientId }: { patientId: string }) => {
  return useApi<GetPreferredPharmacyResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<GetPreferredPharmacyResponse>(
          "/rx/patients/preferred-pharmacy",
          {
            params: {
              patientId,
            },
          },
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.PreferredPharmacy.DEFAULT(patientId),
      select: (data) => {
        return {
          pharmacy: data?.pharmacy ? new Location(data.pharmacy) : undefined,
          pharmacyInvalidReason: data?.pharmacyInvalidReason,
        };
      },
    },
  });
};
